<template lang="pug">
.form(v-loading="loading")
  van-field(v-model="formData.reason" label="事由" disabled)
  van-field(v-model="formData.startDate" label="开始时间" disabled)
  van-field(v-model="formData.endDate" label="结束时间" disabled)
  van-field(v-model="deductDays" label="扣减调休" disabled)
</template>

<script>
import { mapState } from "vuex";
import leaveService from "@/CommonDP/service/leave-service";

export default {
  data () {
    return {
      formData: {},
      loading: false
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      floderObj: state => state.uploaderLocal.floderObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    deductDays() {
      return this.formData.deductDays || "-" + "天";
    }
  },
  mounted () {
    this.getBusinessForm();
  },
  methods: {
    async getBusinessForm() {
      try {
        this.loading = true;
        const res = await leaveService.leaveWtihDraftDetail(this.routerParams.flowInstanceId);
        this.formData = res.data.businessData || {};
        this.loading = false;
      } catch (error) {
        this.$error(error);
      }
    }
  }
};
</script>

<style>

</style>
